/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { DefaultTheme } from 'styled-components/native'

import { LinkSize } from './types'

const iconSizeByLinkSize = ({ theme }: { theme: DefaultTheme }): Record<LinkSize, number> => ({
  default: theme.designSystem.size.icon.m,
  small: theme.designSystem.size.icon.s,
  extraSmall: theme.designSystem.size.icon.s,
})

export const getIconSize = ({ size, theme }: { size: LinkSize; theme: DefaultTheme }) =>
  iconSizeByLinkSize({ theme })[size]
